import type { ApiScan, ScanType } from '@kaiizen/kai-pro-api';

const TURN_BASED_PROJECT_WORK_SCAN_TYPES: readonly ScanType[] = ['initial', 'changeRequest', 'progress', 'audienceDoc'];

/**
 * Determines whether the current user can edit work that is subject to
 * turn-based handoff. The effective type includes unsaved scope deltas, which
 * lets the editor lock as soon as a progress scan becomes a change order.
 */
export const userCanEditTurnBasedProjectWork = ({
  turnBasedHandoff,
  scan,
  effectiveScanType,
  responsibleUserId,
  userId,
}: {
  turnBasedHandoff: boolean;
  scan: ApiScan | undefined;
  effectiveScanType: ScanType | undefined;
  responsibleUserId: string | undefined;
  userId: string | undefined;
}): boolean => {
  const scanType = effectiveScanType ?? scan?.scanType ?? 'initial';
  return !turnBasedHandoff
    || !scan
    || !TURN_BASED_PROJECT_WORK_SCAN_TYPES.includes(scanType)
    || responsibleUserId === userId;
};
